var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[_c('d-header',{attrs:{"fluid":"","actions":[
      {
        label: _vm.$t('create'),
        resource: 'owner',
        path: '/owners/create',
        primary: true,
        color: 'is-primary',
      },
    ]}},[_c('h1',{staticClass:"title"},[_vm._v("\n      "+_vm._s(_vm.$t("owners"))+"\n    ")])]),_vm._v(" "),_c('v-owner-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }